/* =========================================
   Page Transitions
   Uses View Transitions API with fallback
   ========================================= */

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Fade in on initial load
  document.body.style.opacity = '0';
  document.body.style.transition = 'opacity 0.4s ease';

  function fadeIn() {
    document.body.style.opacity = '1';
  }

  if (document.readyState === 'complete') {
    fadeIn();
  } else {
    window.addEventListener('load', fadeIn);
  }

  // Intercept internal navigation
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;

    // Skip external links, anchors, new tabs
    if (
      link.host !== window.location.host ||
      link.getAttribute('href').startsWith('#') ||
      link.target === '_blank' ||
      e.ctrlKey ||
      e.metaKey ||
      e.shiftKey
    ) {
      return;
    }

    e.preventDefault();
    const href = link.href;

    // Use View Transitions API if available
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        return new Promise((resolve) => {
          document.body.style.opacity = '0';
          setTimeout(() => {
            window.location.href = href;
            resolve();
          }, 300);
        });
      });
    } else {
      // Fallback: simple fade
      document.body.style.opacity = '0';
      setTimeout(() => {
        window.location.href = href;
      }, 300);
    }
  });
})();
